const achivements = [
  {
    title: "게임 <잊혀진 서재 확장판>의 발자취",
    items: [
      {
        img: "achive-comic_world.png",
        title: "코믹월드 WINTER 2025",
        desc: "국내 최대 규모의 만화 이벤트 행사, 코믹월드! <코믹월드 인디게임존>에서 만나요",
        link: "https://store.onstove.com/ko/games/3957",
        target: "_blank",
      },
      {
        img: "achive-mogumogu.png",
        title: "청년이룸 모구모구 2기",
        desc: "청년 문화예술 소모임 지원사업, <모구모구 2기>로 함께한 즐거운 시간!",
      },
      {
        img: "achive-beaver_rocks.png",
        title: "BEAVER ROCKS 2025",
        desc: "비버락스 2025 온라인 전시팀 선발! 올 겨울, 온라인 전시로 만나요",
        link: "https://www.youtube.com/watch?v=YOAHiQlOORU",
        target: "_blank",
      },
      {
        img: "achive-comic_world.png",
        title: "코믹월드 SUMMER 2025",
        desc: "국내 최대 규모의 만화 이벤트 행사, 코믹월드! <코믹월드 인디게임존>에서 함께한 7월",
        link: "https://store.onstove.com/ko/games/3957",
        target: "_blank",
      },
      {
        img: "achive-cheonan_k-culture.png",
        title: "2025 천안 K-컬처 박람회",
        desc: "독립기념관에 어울리는 한국풍 이야기로 독립게임존 부스 참여!",
        link: "https://www.instagram.com/p/DKHlYIlBith",
        target: "_blank",
      },
      {
        img: "achive-tumblbug.png",
        title: "새롭게 만나는 스토리 방탈출 게임",
        desc: "<잊혀진 서재> 확장판, 텀블벅 크라우드 펀딩 232% (4,658,900원) 달성",
        link: "https://tumblbug.com/lostlibrary",
        target: "_blank",
      },
    ],
  },
  {
    title: "게임 <잊혀진 서재>의 발자취",
    items: [
      {
        img: "achive-gstar.png",
        title: "G-Star 2024 인디쇼케이스",
        desc: "PC 확장판 최초 공개부터 한정판 굿즈까지!",
        link: "https://www.instagram.com/p/DCIm2h6hwcP/?igsh=MXdvaHpkbGdzajVmOQ===",
        target: "_blank",
      },
      {
        img: "achive-indie_craft.png",
        title: "인디크래프트 챌린저 부문 TOP 20 선정",
        desc: "인디크래프트 2024 챌린저 부문 TOP 20 선정, GXG 전시",
        link: "https://www.instagram.com/p/C_NxP7eBDGp/?igsh=MTE0Z3V5MTZuZ25iNA==",
        target: "_blank",
      },
      {
        img: "achive-gstar.png",
        title: "G-Star 2023 인디쇼케이스",
        desc: "스토리 수집형 방탈출 게임을 더 많은 유저와 함께!",
        link: "https://www.instagram.com/p/Cz-5xiXBqH-/?igshid=MzRlODBiNWFlZA==",
        target: "_blank",
      },
      {
        img: "achive-tumblbug.png",
        title: "모험가의 기대를 받은",
        desc: "텀블벅 크라우드 펀딩 223%(3,359,370원) 달성",
        link: "https://tumblbug.com/sonak/community/creator?ref=%EA%B2%80%EC%83%89%2F%ED%82%A4%EC%9B%8C%EB%93%9C",
        target: "_new",
      },
      {
        img: "achive-appstore.png",
        title: "퍼즐과 스토리의 만남",
        desc: "앱스토어 퍼즐 부문 최고순위 19위",
        link: "/link/",
        target: "_new",
      },
      {
        img: "achive-onestore.png",
        title: "이달의 인디게임",
        desc: "원스토어 2023년 10월 이달의 인디게임 선정, 원스토어 인기 최고순위 7위",
        link: "/link/",
        target: "_new",
      },
    ],
  },
  {
    title: "그 외 소낙의 발자취",
    items: [
      {
        img: "achive-expert.png",
        title: "심리테스트 전문가",
        desc: "인터랙티브 콘텐츠 누적 참여자 100000명 돌파 (2025.05.28 기준)",
        link: "/web",
        target: "_self",
      },
      {
        img: "achive-cliche.png",
        title: "클리셰 박사",
        desc: "클리셰개론 참여자 34000명 (2025.05.28 기준)",
        link: "https://www.metavv.com/ko/content/10045978",
        target: "_new",
      },
      {
        img: "achive-romance.png",
        title: "로맨스판타지 주인공",
        desc: "로맨스판타지 심리테스트 참여자 43000명 (2025.05.28 기준)",
        link: "https://www.metavv.com/ko/content/10861539",
        target: "_new",
      },
      {
        img: "achive-first_love.png",
        title: "이야기 속 첫사랑",
        desc: "첫사랑 자아 테스트 참여자 14200명 (2025.05.28 기준)",
        link: "https://www.metavv.com/content/10048149",
        target: "_new",
      },
    ],
  },
];

export default achivements;
